import TemplateView from '../../../../TemplateView'
import CustomCheckbox from '../../../../components/customCheckbox/CustomCheckbox'
import {CustomCheckBoxSize} from '../../../../components/customCheckbox/constants'

export default class CardDetailsFooter extends TemplateView {

    constructor({
        saveCardCheckboxCallback = () => {},
    }) {
        super()

        this.callbacks = {
            saveCardCheckboxCallback,
        }

        this.state = {
            checked: false,
            showCheckbox: false,
            checkboxText: '',
        }

        this.onStatePropertyChanged('checked', (checked) => {
            this.checkbox.setState({checked})
        })

        this.onStatePropertyChanged('showCheckbox', (showCheckbox) => this.checkbox.toggle(showCheckbox))

        this.onStatePropertyChanged('checkboxText', (checkboxText) => this.checkbox.setState({label: checkboxText}))
    }

    templateHtml() {
        return `<div class="cardDetailsFooter">
                    <div class="saveCardCheckbox"/>
                    <div class="stripeContainer">
                        <div class="textContainer">
                            <a class="link securedText"><%=secured%></a>
                            <a href="https://stripe.com/docs/security/stripe/" target="_blank" class="securedText"><%=stripe%></a>
                        </div>
                        <div class="stripeIconOuter">
                            <div class="stripeIconInner"/>
                        </div>
                    </div>
                </div>`
    }

    messageKeys() {
        return {
            secured: 'licenses.card_details.secured',
            stripe: 'licenses.card_details.stripe',
        }
    }

    afterRender() {
        this.checkbox = new CustomCheckbox({
            checked: this.state.checked,
            checkboxTitleAdditionalClass: 'checkboxText',
            onChange: () => this.callbacks.saveCardCheckboxCallback(),
            size: CustomCheckBoxSize.LITTLE,
        }).init(this.find('.saveCardCheckbox'))
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/creditCard/CardDetailsFooter.js